import React,{useState,useEffect} from 'react'
import { Button, Accordion, Divider} from 'selfly-ui-react';

import MultiSelect from './../multiSelect'
import { AlarmCategories, InputField } from './../Selectables'
import {DeletePermissionModal} from './../alarmInfoModal'

const OtherUsers = ({alarmSettings, locations, saveChanges, deleteConfig})=>{

    const [userSettings, setUserSettings] = useState(null)
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)
    const [settingId, setSettingId] = useState(null)

    useEffect(()=>{
       const settings = [...alarmSettings]
       
       const arrangeById = {}
       settings.forEach(setting=>{
            arrangeById[setting.id]={...setting, receivers:setting.receivers.map((receiver,index)=>{return {index,value:receiver}})}
       })
       setUserSettings(arrangeById)

    },[alarmSettings])

    // when user selectes location
    const onLocationChange=(locationArray, id)=>{
        setUserSettings((prevState)=>{
            return {...prevState, [id]:{...prevState[id], locationIds:locationArray}}
        })
    }

    // when user selects alertTypes
    const onAlertTypesChange =(alert, id)=>{
        setUserSettings((prevState)=>{
            return {...prevState, [id]:{...prevState[id], alertTypes:alert}}
        })
    }

    // when user adds/removes receivers
    const onReceiversChange =(emails,id)=>{
        setUserSettings((prevState)=>{
            return {...prevState, [id]:{...prevState[id], receivers:emails}}
        })
    }

    const sendToSaveChanges=(configId)=>{        
        saveChanges(userSettings[configId])
    }

    useEffect(()=>{
        if(!deletePermission){
            setConfirmationModalOpen(false)
            setSettingId(null)
            return
        }
        deleteConfig(settingId)
        setConfirmationModalOpen(false)
        setSettingId(null)
    },[deletePermission])

    return <div className="settings__item settings__item-gap">
            {alarmSettings.map(setting=>
                <Accordion  
                    icon="user"
                    title={setting.userName}
                    key={setting.id}
                    className="settings__item-list"
                >
                    <DeletePermissionModal
                        confirmationOpen={confirmationModalOpen}
                        deleteForever={(permission)=>{
                            setConfirmationModalOpen(false)
                            setDeletePermission(permission)
                        }}
                        message='Deleting will remove the alarm settings and subscribers no longer will be able to receive any email notifications when any incidents occour in your cabinets.'
                    />
                    <div className="settings__item-label">Select cabinet locations</div>
                    <MultiSelect 
                        locations={locations}
                        selectedLocations={userSettings && userSettings[setting.id] && userSettings[setting.id].locationIds || []} 
                        locationChange={(locationArray)=> {onLocationChange(locationArray, setting.id) }}
                    />
                    <AlarmCategories
                        alertTypes={userSettings && userSettings[setting.id] && userSettings[setting.id].alertTypes}
                        updateAlertTypes = {(alert)=>{onAlertTypesChange(alert,setting.id)}}
                    />
                    {userSettings && userSettings[setting.id] && userSettings[setting.id].receivers && userSettings[setting.id].receivers.length > 0 && <div className="settings__item-label">All alarm receivers</div>}
                    <div className="scrollable">
                        <InputField 
                            inputs={userSettings && userSettings[setting.id] && userSettings[setting.id].receivers} 
                            inputUpdated={(updatedReceivers) => {onReceiversChange(updatedReceivers, setting.id)}}
                        />
                    </div>
                    <div className="settings__item">
                        <div className="settings__item-config">                                
                            <Divider/>
                            <div className="settings__button-group">
                                <Button
                                    icon="save"
                                    type="positive"
                                    onClick={() => {
                                       sendToSaveChanges(setting.id)
                                    }}
                                >
                                    Save changes
                                </Button>
                                {
                                    <Button
                                        icon="delete_forever"
                                        type="negative"                                    
                                        onClick={() => {
                                            setSettingId(setting.id)
                                            setConfirmationModalOpen(true)
                                        }}
                                    >
                                        Delete 
                                    </Button>
                                }                                
                            </div>
                        </div>
                    </div>
                </Accordion>
            )}
        </div>
}

export default OtherUsers